import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { EnvironmentTypes } from 'shared/constants/environmentTypes';
import { permissionsTypes } from 'shared/constants/permissionsTypes';
import { licencesTypes } from 'shared/constants/licencesTypes';
import { allStandardRolesTypes, organisationAdmin } from 'shared/constants/rolesTypes';
import { mergePermissionsParser, validateRoles } from 'shared/parsers';
import { validateShopPermissions } from 'modules/shop/shared/parsers';

const RenderElement = ({
  children,
  condition,
  environment,
  permission,
  licence,
  role,
  shopPermissions: shopRoles,
}) => {
  const auth = useSelector(state => state.auth);
  const { permissions, licences, roles, shopPermissions } = auth.data;

  const mergedPermissions = permissions ? mergePermissionsParser(permissions) : [];

  const checkEnvironment = environment ? environment === process.env.REACT_APP_ENV : true;
  const checkPermission = permission ? mergedPermissions.includes(permission) : true;
  const checkLicence = licence ? licences.includes(licence) : true;
  const checkRole = role ? validateRoles(roles, role) : true;
  const checkShopPermissions =
    shopRoles && shopRoles.length ? validateShopPermissions(shopPermissions, shopRoles) : true;

  return (
    checkEnvironment &&
    checkPermission &&
    checkLicence &&
    checkRole &&
    checkShopPermissions &&
    condition &&
    children
  );
};

RenderElement.defaultProps = {
  environment: null,
  permission: null,
  licence: null,
  role: null,
  shopPermissions: [],
  condition: true,
};

RenderElement.propTypes = {
  children: PropTypes.node.isRequired,
  environment: PropTypes.oneOf([...Object.values(EnvironmentTypes), null]),
  permission: PropTypes.oneOf([...Object.keys(permissionsTypes), null]),
  licence: PropTypes.oneOf([...Object.keys(licencesTypes), null]),
  role: PropTypes.oneOf([...allStandardRolesTypes, allStandardRolesTypes, organisationAdmin, null]),
  shopPermissions: PropTypes.arrayOf(PropTypes.string),
  condition: PropTypes.bool,
};

export { RenderElement };
